import React from 'react';
import {Slide, Zoomn ,Bounce, Zoom } from 'react-awesome-reveal'
import AZ from '../../assets/logos/logo2.png'
import YouTubeModalButton from '../Sections/YouTubeModalButton';


const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.3,
      },
    },
  };
  
  const itemVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };
  
  const imageVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.6, ease: 'easeOut' } },
    hover: { scale: 1.05 },
  };
  

const MainContainer3 = () => {
  return (
    <section id="main-container" className="main-container" 
    style={{
      backgroundImage:'url(images/assets/ban6.jpg)',
      borderTop:'10px #917232 solid',
       backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        backgroundPosition: 'center',  
      }}
    >
      <div className="container">
      <div className="text-center mb-3">
                      <Bounce>
                        <img src={AZ} alt="logo" className="img-fluid mb-3" style={{ maxWidth: 400 }} />
                      </Bounce>
                    
                    </div>
        <div className="row">
          {/* Colonne gauche */}
          <div className="col-lg-12">
          <Slide direction="left">
            <h1 className="column-title" style={{fontFamily:'Times',color:'#fbe19a'}}><b>
          Il vous suffit de nous exposer vos besoins en sécurité, et nous déployons les solutions pour les concrétiser avec efficacité et fiabilité. 
                 </b></h1>
            </Slide>
         
       
            
          </div>
         
        
       

          {/* Colonne droite */}
        
        </div> {/* Row end */}
      </div> {/* Container end */}
    </section>
  );
};

export default MainContainer3;
